<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <el-button type="primary"  @click="addUser">添加</el-button>
                <el-button type="danger"  @click="delAll">删除</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                    <el-table-column prop="username" label="用户名" sortable="custom"></el-table-column>
                    <el-table-column prop="realname" label="姓名" sortable="custom"></el-table-column>
                    <el-table-column prop="org_name" label="所在机构" sortable="custom"></el-table-column>
                </el-table>
            </div>
        </div>
        <UserSelect
            width="1200px"
            title="选择用户"
            :isshow="show_user_list"
            @setUser="setUser"
            @on-close="closeSelDialog">
        </UserSelect>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import { getListData, delData } from '@/api/common'
import { bindCryptoUser, unBindCryptoUser } from '@/api/cryptodog'
import UserSelect from "../user/userselect"

export default {
    name: 'cryptoUserList',
    mixins: [listutil],
    components: {UserSelect},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        code: {
            type: String,
            default() {
                return "";
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '加密狗绑定用户',
            menu_id: 9999,
            search_Obj: {
                f_xxx: '',
            },
            list_url: "/api/admin/cryptodog/bindUserList",
            del_Obj:{
                url:'/api/admin/cryptodog/delUser',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            showflag: false,
            show_user_list: false,
            user_ids: '',
        };
    },
    methods: {
        getListData() {
            this.loading = true;
            this.selectData = [];
            let codeObj = {
                "code": this.code
            }
            getListData(this.list_url, codeObj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data;
                }
            })
        },
        closeDialog() {
            this.$emit("on-close")
        },
        addUser(){
            this.show_user_list = true
        },
        setUser(user_ids){
            this.user_ids = user_ids
            bindCryptoUser(this.code, this.user_ids).then(res=>{
                if (res.code == 1) {
                    this.$msgs("绑定成功")
                } else {
                    this.$msg(res.msg)
                }
                this.closeSelDialog()
            })
        },
        delAll(){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要解绑的用户")
            } else {
                let ids = '';
                for (let data of this.selectData) {
                    if (ids === '') {
                        ids = data.id + "";
                    } else {
                        ids += "," + data.id;
                    }
                }
                unBindCryptoUser(this.code, ids).then(res => {
                    if (res.code == 1) {
                        this.$msgs("解绑成功")
                        this.getListData();
                    } else {
                        this.$msg(res.msg)
                    }
                })
            }
        },
        closeSelDialog(){
            this.show_user_list = false
            this.getListData()
        },
    }
};
</script> 